import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  customerLookupDetailsData: {},
  error: "",
  success: false,
  status: "",
};

const customerLookupDetails = createAsyncThunk(
  "customer/lookup",
  async (mobile) => {
    
    try {
      const result = await axios.get(
        `https://apac-apigateway.capillarytech.com/mobile/v2/api/customers/lookup/customerDetails`
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const customerLookupDetailsSlice = createSlice({
  name: "customer-lookup",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(customerLookupDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(customerLookupDetails.fulfilled, (state, action) => {
    
      state.loading = false;
      state.customerLookupDetailsData =
        action?.payload?.profiles && action?.payload?.profiles[0];
      state.success = action?.payload.hasOwnProperty("errors")
        ? action?.payload?.errors[0]?.status
        : true;
      state.error = action?.payload.hasOwnProperty("errors")
        ? action?.payload?.errors[0]?.message
        : "";
    });
    builder.addCase(customerLookupDetails.rejected, (state, action) => {
      state.loading = false;
      state.customerLookupDetailsData = [];
      state.error = action.error.message;
    });
  },
});

export default customerLookupDetailsSlice.reducer;
export { customerLookupDetails };
